import React from "react";
import styles from "../../styles/common/unauthorized.module.css";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useUser } from "../../context/AuthContext";

const Unauthorized = ({ requiredModule, children }) => {
  const { user, module } = useUser();

  // Handle loading state: If user data is not ready, show nothing (avoids flicker)
  if (!user || module === undefined) {
    return null; // Don't render anything while loading
  }

  const hasAccess =
    (user?.companyAdmin && !user?.isSubCompanyAdmin) ||
    user?.facilityManger ||
    (user?.groupManager && !user?.subGroupManager) ||
    (requiredModule && module?.includes(requiredModule));

  if (!hasAccess) {
    return (
      <div className={styles.unauthorized}>
        <div className={styles.card}>
          <WarningAmberIcon
            sx={{
              width: "50px",
              height: "50px",
              color: "rgb(215, 60, 60)",
              marginBottom: "0.5rem",
            }}
          />
          <p className={styles.card_title}>Access Restricted</p>
          <p className={styles.card_description}>
            You do not have permission to access this section of the VAJRA
            Platform.
          </p>
          <p className={styles.card_description}>
            If you believe this is an error, please contact support or request
            access.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default Unauthorized;
